import { useEffect, useState } from 'react';

export default function usePopup(
  boundryElementID: string,
  referenceElement: HTMLElement,
  popperElement: HTMLElement,
  options: {
    direction: 'left' | 'right' | 'bottom-left' | 'bottom-right' | 'bottom';
  }
) {
  const [styles, setStyles] = useState<any>({
    display: 'none',
    position: 'fixed',
    zIndex: 200,
  });
  const show = () => {
    setStyles((s) => ({ ...s, display: 'block' }));
  };
  const hide = () => {
    setStyles((s) => ({ ...s, display: 'none' }));
  };
  useEffect(() => {
    if (referenceElement && popperElement) {
      const modifications: any = {};
      const boundaryElement = document.getElementById(boundryElementID);
      const boundingRect = boundaryElement?.getBoundingClientRect();
      const refRect = referenceElement.getBoundingClientRect();
      const popperRect = popperElement.getBoundingClientRect();
      // attempt to align midline of refereceElement and popperElement
      let x =
        options.direction === 'right'
          ? refRect.x + refRect.width
          : refRect.x - popperRect.width;
      let y = refRect.y + refRect.height / 2 - popperRect.height / 2;

      modifications.left = x;
      modifications.top = y;

      if (options.direction === 'bottom') {
        // align the horizontal mid points of refElement and popperElement
        modifications.left =
          refRect.x + refRect.width / 2 - popperRect.width / 2;
      }

      if (boundingRect) {
        // attempt to align top of boundaryElement
        if (modifications.top < boundingRect.y) {
          modifications.top = boundingRect.y;
        }

        // attemp to align to bottom of boundaryElement
        if (
          boundingRect.y + boundingRect.height <
          modifications.top + popperRect.height
        ) {
          modifications.top =
            boundingRect.y + boundingRect.height - popperRect.height;
        }

        if (modifications.left < boundingRect.x) {
          modifications.left = boundingRect.x;
        }

        if (
          modifications.left + popperRect.width >
          boundingRect.x + boundingRect.width
        ) {
          modifications.left =
            boundingRect.x + boundingRect.width - popperRect.width;
        }
      }
      setStyles((s) => ({
        ...s,
        ...modifications,
      }));
    }
  }, [referenceElement, popperElement]);
  return { styles, show, hide };
}
